import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import { connect } from "react-redux";
import Drawer from "../../Drawer/Drawer";
import * as actions from "../../../actions";
import SelectSlot from "../../PathlabSlots/SelectSlot";
import ValidationModal from "../../../components/DiagnosticsCart/ValidationModal";
import GeneralModal from "../../../components/DiagnosticsCart/GeneralModal";

require("./AppointmentPreference.scss");

class AppointmentPreference extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: true,
      showValidationModal: false,
      showErrorModal: false,
      ValidationModalText: "",
    };
  }

  handleChangeClick = () => {
    this.setState({
      openDrawer: true,
    });
  };

  openSlotDrawer = () => {
    this.setState({
      showValidationModal: false,
      showErrorModal: false,
      openDrawer: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      openDrawer: false,
    });
  };

  checkValidationOnSameOrder = () => {
    const {
      selectedAddress,
      selectedSlot,
      selectedPatient,
      selectedPromocode,
    } = this.props;

    const paramsObj = {
      address_id: selectedAddress.id,
      slot_date: selectedSlot.date,
      patient_id: +(selectedPatient.tenantPatientId),
      promocode:
        (selectedPromocode &&
          selectedPromocode.data &&
          selectedPromocode.data.couponCode) ||
        null,
    };
    this.props.actions.getValidationOnSameOrder(paramsObj).then((response) => {
      const { error, status, data } = response;

      if (!error && status && data && data.activeOrder) {
        this.setState({
          showValidationModal: true,
          ValidationModalText: data.activeOrderMessage,
        });
      } else if (error && error.show_alert && !status) {
        this.setState({
          showErrorModal: true,
          ValidationModalText: error.message,
        });
      }
    });
  };

  tConvert = (times) => {
    // Check correct time format and split into components
    let time = times
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [times];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      time.splice(3, 2);
    }
    return time.join(""); // return adjusted time or original string
  };

  render() {
    const { selectedSlot, selectedAddress, selectedPatient } = this.props;
    const { pincode, cityId } = selectedAddress || {};
    const {
      openDrawer,
      showValidationModal,
      ValidationModalText,
      showErrorModal,
    } = this.state;

    return (
      <div className="appointmentPreferenceContainer">
        <div className="appointmentTitleWrapper">
          <span className="appointmentTitle">
            Select Appointment Preference
          </span>
          <button className="changeBtnSlot" onClick={this.handleChangeClick}>
            {isEmpty(selectedSlot) ? "Select Slot" : "Change"}
          </button>
        </div>
        {!isEmpty(selectedSlot) && (
          <div className="date">
            {moment(selectedSlot.date).format("dddd")},{" "}
            {moment(selectedSlot.date).format("DD MMM")}
          </div>
        )}
        {!isEmpty(selectedSlot) && (
          <div className="time">
            {this.tConvert(selectedSlot.start_time)} -{" "}
            {this.tConvert(selectedSlot.end_time)}
          </div>
        )}
        <Drawer
          open={openDrawer}
          onClose={this.closeDrawer}
          isBackDropDismissable={false}
        >
          <SelectSlot
            doneClick={this.closeDrawer}
            checkValidationOnSameOrder={this.checkValidationOnSameOrder}
            selectedPincode={pincode}
            selectedCityID={cityId}
            selectedPatient={selectedPatient}
          />
        </Drawer>
        {showValidationModal && (
          <ValidationModal
            show={showValidationModal}
            bodyText={ValidationModalText}
            onYes={null}
            onNo={this.openSlotDrawer}
          />
        )}

        {showErrorModal && (
          <GeneralModal show={showErrorModal} bodyText={ValidationModalText} />
        )}
      </div>
    );
  }
}

AppointmentPreference.propTypes = {
  selectedSlot: PropTypes.object,
  selectedAddress: PropTypes.object,
  selectedPatient: PropTypes.object,
  selectedPromocode: PropTypes.object,
};

AppointmentPreference.defaultProps = {
  selectedSlot: {},
  selectedAddress: {},
  selectedPatient: {},
  selectedPromocode: {},
};

export default connect(
  (state) => ({
    selectedSlot: state.diagnosticsSlots.selectedSlot,
    selectedAddress: state.patients.selectedAddress,
    selectedPatient: state.patients.selectedPatient,
    selectedPromocode: state.cart.promocode,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(AppointmentPreference);
